import React, { ReactNode } from 'react'
import {
  ActionButtonGroup,
  ActionButtonGroupProps
} from '@contrast-security-inc/design-system-actions'
import { ActionProps } from './action'

export interface ActionListProps extends ActionButtonGroupProps {
  readonly children: ReactNode
  readonly className?: string
  readonly large?: boolean
  readonly isRelatedPopoverOpen?: boolean
}

export const rowActionListDataTestId = 'row-action-list-container'

export function ActionList({
  children,
  className,
  large,
  ...rest
}: ActionListProps) {
  return (
    <ActionButtonGroup
      testId={rowActionListDataTestId}
      className={className}
      alignItems="center"
      spacing={large ? '16px' : '8px'}
      {...rest}
    >
      {React.Children.map(children, (child) => {
        return React.isValidElement(child)
          ? React.cloneElement(child, {
              size: large ? 'md' : 'sm'
            } as const as ActionProps)
          : child
      })}
    </ActionButtonGroup>
  )
}
